<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_11"></a>PART ONE<br/>E<span class="small">XCERPTS FROM THE</span> N<span class="small">OVELS</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?08796f58